define('components/photoset/layouts/base/row', [], function () {
    function Model(jsonModel) {
        const isVisible = ko.observable(true);

        this.isVisible = ko.pureComputed({
            read: () => isVisible(),

            write: value => {
                this._updateItemsVisibility(value);
                isVisible(value);
            }
        });
    }

    Model.prototype._updateItemsVisibility = function () { }

    return Model;
});